/* 🤖 this file was generated by svg-to-ts */
export const mgcIconEaseOutCuteRe: {
  name: 'ease-out-cute-re';
  data: string;
} = {
  name: 'ease-out-cute-re',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M19.34 3.027c-6.291.303-11.696 5.351-15.386 14.37-.462 1.128-.918 2.345-.941 2.507-.029.216.073.558.221.736.226.273.707.423 1.03.321.24-.076.445-.225.56-.407.057-.091.254-.555.438-1.03 1.236-3.205 2.224-5.199 3.638-7.344.885-1.342 1.694-2.34 2.757-3.401 1.72-1.716 3.319-2.723 5.278-3.326.837-.257 2.053-.452 2.828-.453.47 0 .708-.078.934-.303.183-.183.303-.46.303-.697s-.12-.514-.303-.697c-.282-.281-.467-.319-1.357-.276"/></svg>`
};
